<template>
  <div id="honor" style="min-height:600px;min-width: 1200px">
    <!--:style="'background-image: url(' + tempdata.imageUrl + ')'"-->
    <img :src="tempdata.imageUrl" alt="" style="
         border: 0;
         margin-bottom: -5px;
         padding: 0;
         width: auto;
         height: auto;
         max-width: 100%;
         max-height: 100%;">
  </div>
</template>

<script>
  var _this;
  //模拟数据

  var arrinfo = [];
  export default {
    name: 'honor',
    data() {
      return {
        msg: '荣耀殿堂',
        // theData:'',
        tempdata: '',
      }
    },
    //监听
    watch: {},

    //事件处理
    methods: {
      //    获取数据
      requestHonerIntro: function (offset) {
        this.request.get({
          url: '/about/text/2',
          params: {},
          callback: function (data) {
            _this.tempdata = data.data;
            if (data.data.length == 0) return;

          }.bind(this)
        })
      },
    },

    //实例加载完成后
    created() {
      // this.theData=arrinfo;
      this.requestHonerIntro();
    },

    //页面完成以后
    mounted: function () {
      _this = this;
      //    获取数据
      /*for (let i = 0; i < $(".honorlist").length; i++) {
        $(".honorlist").eq(i).animate({height: '100px'}, i * 200);
      }*/
    },
  }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/honor.vue